import Message from '@standardsdigital/ui-components/Message';
import RadioGroup from '@standardsdigital/ui-components/RadioGroup';
import RadioGroupItem from '@standardsdigital/ui-components/RadioGroupItem';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';

interface UpdateExistingSubscriptionsRadioProps {
  value: boolean;
  onChange: (value: boolean) => void;
  isDirty: boolean;
  disabled: boolean;
}

function UpdateExistingSubscriptionsRadio({
  value,
  onChange,
  isDirty,
  disabled,
}: Readonly<UpdateExistingSubscriptionsRadioProps>) {
  const { t } = useTranslation();

  return (
    <>
      <FieldStatusWrapper isDirty={isDirty}>
        <RadioGroup
          label={t('serviceLevels.form.updateExistingSubscriptions')}
          layout="horizontal"
          value={String(value)}
          onValueChange={(nextValue) => onChange(nextValue === 'true')}
          disabled={disabled}
        >
          <RadioGroupItem
            value="false"
            label={t('serviceLevels.no')}
            disabled={disabled}
          />
          <RadioGroupItem
            value="true"
            label={t('serviceLevels.yes')}
            disabled={disabled}
          />
        </RadioGroup>
      </FieldStatusWrapper>
      {value ? (
        <Message variant="warning">
          {t('serviceLevels.form.updateExistingSubscriptionsWarning')}
        </Message>
      ) : null}
    </>
  );
}

export default UpdateExistingSubscriptionsRadio;
